import { defineComponent as _defineComponent } from 'vue'
import { Button } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';
  import { useCourseTakeStore } from '@/stores/trainings/courseTake';
  import { storeToRefs } from 'pinia';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTakeButtons',
  setup(__props) {

  const courseTake = useCourseTakeStore();
  const { hasPrevious, hasNext } = storeToRefs(courseTake);

return { __sfc: true,courseTake, hasPrevious, hasNext, Button, Icon }
}

})